import { RedFooterModel } from 'models/RedFooterModel';
import { ApiVersion } from 'models/ApiVersion';
import { FooterModel } from 'models/FooterModel';

export const legacyFooter: FooterModel = {
  version: ApiVersion.Legacy,
  copyright: {},
  contactInfo: {
    phonenumber: '',
    openingInfo: '',
    openingBody: '',
    greeting: '',
    contactUrl: '',
    contactCaption: '',
    openingInfoCustomerService: '',
    isCritical: false
  },
  reviewInfo: {
    imageUrl: '',
    $score: '',
    reviews: '',
    scoreCaption: '',
    header: ''
  },
  helpHeader: '',
  helpBody: '',
  aboutHeader: '',
  aboutBody: '',
  aboutReadMoreText: '',
  aboutReadMoreLink: '',
  footerGroups: []
};

export const initialState: RedFooterModel = {
  version: ApiVersion.RD3,
  copyright: {},
  allFooterGroups: [],
  socialLinks: []
};

export default (state: RedFooterModel = initialState) => state;
